export default __webpack_public_path__ + "static/staring-a6b8f23d83213a66fa0600752806c1cf.svg";